export default __webpack_public_path__ + "static/media/information-panel-background.cc76fa1a.svg";